import {
  isSmartelds,
  isUnity,
  isEldBooks,
  isBluehorse,
  isVulcansols,
  isRadical,
  isApex,
  isRoadwise,
  isEldNN,
  isSt,
  isTe,
  isEt,
  isSaferEld,
} from "../configureStore";

import {
  LOGO_SM,
  LOGO_UNITY,
  LOGO_EB,
  SM_LOGO_BH,
  LOGO_VS,
  LOGO_RE,
  LOGO_AU,
  LOGO_RW,
  LOGO_NN,
  LOGO_ST,
  LOGO_TE,
  LOGO_ET,
  LOGO_SA
} from "../utils/logos";

let htmlHeadDefault = {
  favicon: "/favicon-reseller.ico",
  title: "ELD",
  description: "FMCSA Registered ELD Solution",
  author: "ELD",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking, Ai",
};

let htmlHeadSe = {
  favicon: "/favicon.ico",
  title: "Smartelds",
  description: "FMCSA Registered ELD Solution",
  author: "Asritsolutions LLC",
  keyword: "ELD, Smartelds, FMCSA, IFTA, HOS, Tracking, Ai",
};

let htmlHeadUnity = {
  favicon: "/favicon-unity.ico",
  title: "Motioneld",
  description: "FMCSA Registered ELD Solution",
  author: "Unity Eld LLC",
  keyword: "ELD, Motion, Unity, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadEb = {
  favicon: "/favicon-eldbooks.ico",
  title: "Eldbooks",
  description: "FMCSA Registered ELD Solution",
  author: "Asritsolutions LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking, Ai",
};

let htmlHeadBh = {
  favicon: "/favicon-bluehorse.ico",
  title: "Bluehorse",
  description: "FMCSA Registered ELD Solution",
  author: "Blue horse ELD Inc",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadVs = {
  favicon: "/favicon-vulcansols.ico",
  title: "Vulcansols",
  description: "FMCSA Registered ELD Solution",
  author: "Blue horse ELD Inc",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadRe = {
  favicon: "/favicon-radical.ico",
  title: "Radical",
  description: "FMCSA Registered ELD Solution",
  author: "Radical ELD LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadAu = {
  favicon: "/favicon-apex.ico",
  title: "Apex Ultima",
  description: "FMCSA Registered ELD Solution",
  author: "Apex ELD LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadRw = {
  favicon: "/favicon-roadwise.ico",
  title: "Roadwise ELD",
  description: "FMCSA Registered ELD Solution",
  author: "Roadwise ELD LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadNN = {
  favicon: "/favicon-eld99.ico",
  title: "Eld99",
  description: "FMCSA Registered ELD Solution",
  author: "FireFly Systems LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadSt = {
  favicon: "/favicon-securetrack.ico",
  title: "Securetrack",
  description: "FMCSA Registered ELD Solution",
  author: "Rehmat solutions LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadTe = {
  favicon: "/favicon-securetrack.ico",
  title: "Trackease",
  description: "FMCSA Registered ELD Solution",
  author: "Alina Ayyan Inc",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadEt = {
  favicon: "/favicon-trex.ico",
  title: "Eldtrex",
  description: "FMCSA Registered ELD Solution",
  author: "Eldtrex Inc",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadSa = {
  favicon: "/favicon-safer.ico",
  title: "Safereld",
  description: "FMCSA Registered ELD Solution",
  author: "Safereld Inc",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

const smarteldsAdminConfig = {
  payments: true,
  reseller: true,
  settings: true,
};
const unityAdminConfig = {
  payments: false,
  reseller: false,
  settings: true,
};
const eldBooksAdminConfig = {
  payments: true,
  reseller: true,
  settings: true,
};
const bluehorseAdminConfig = {
  payments: false,
  reseller: false,
  settings: true,
};
const vulcansolsAdminConfig = {
  payments: false,
  reseller: false,
  settings: true,
};
const radicalAdminConfig = {
  payments: false,
  reseller: false,
  settings: false,
};
const apexAdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const roadwiseAdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const eldNNAdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const eld247AdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const teAdminConfig = {
  payments: false,
  reseller: false,
  settings: true,
};
const etAdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const saAdminConfig = {
  payments: false,
  reseller: false,
  settings: false,
};

const smarteldsNavConfig = {
  settings: true,
  reseller: true,
};
const unityNavConfig = {
  settings: false,
  reseller: false,
};
const eldBooksNavConfig = {
  settings: false,
  reseller: true,
};
const bluehorseNavConfig = {
  settings: false,
  reseller: false,
};
const vulcansolsNavConfig = {
  settings: false,
  reseller: false,
};
const radicalNavConfig = {
  settings: false,
  reseller: false,
};
const apexNavConfig = {
  settings: false,
  reseller: true,
};
const roadwiseNavConfig = {
  settings: false,
  reseller: false,
};
const eldNNNavConfig = {
  settings: false,
  reseller: false,
};
const eld247NavConfig = {
  settings: false,
  reseller: false,
};
const teNavConfig = {
  settings: false,
  reseller: false,
};
const etNavConfig = {
  settings: false,
  reseller: true,
};
const saNavConfig = {
  settings: false,
  reseller: false,
};

let LOGO_STYLES_SE = { maxWidth: 150, maxHeight: 28, margin: "auto" };

let LOGO_STYLES_UNITY = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 95,
  marginTop: -25,
  marginBottom: -25,
};

const LOGO_STYLES_EB = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 55,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_BH = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 55,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_VS = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 55,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_RE = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 45,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_AU = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 55,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_RW = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 60,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_NN = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 60,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_ST = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 65,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

const LOGO_STYLES_TE = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 40,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};
const LOGO_STYLES_ET = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 55,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};
const LOGO_STYLES_SA = {
  maxWidth: 150,
  margin: "auto",
  maxHeight: 55,
  marginTop: -25,
  marginBottom: -25,
  marginLeft: 25,
};

export const LOGO_STYLES = isSmartelds
  ? LOGO_STYLES_SE
  : isUnity
  ? LOGO_STYLES_UNITY
  : isEldBooks
  ? LOGO_STYLES_EB
  : isBluehorse
  ? LOGO_STYLES_BH
  : isVulcansols
  ? LOGO_STYLES_VS
  : isRadical
  ? LOGO_STYLES_RE
  : isApex
  ? LOGO_STYLES_AU
  : isRoadwise
  ? LOGO_STYLES_RW
  : isEldNN
  ? LOGO_STYLES_NN
  : isSt
  ? LOGO_STYLES_ST
  : isTe
  ? LOGO_STYLES_TE
  : isEt
  ? LOGO_STYLES_ET
  : isSaferEld
  ? LOGO_STYLES_SA
  : LOGO_STYLES_SE;

export const APP_STYLE_ID = isSmartelds
  ? "app-smartelds"
  : isUnity
  ? "app-unity"
  : isEldBooks
  ? "app-eldbooks"
  : isBluehorse
  ? "app-bluehorse"
  : isVulcansols
  ? "app-vulcansols"
  : isRadical
  ? "app-radical"
  : isApex
  ? "app-apex"
  : isRoadwise
  ? "app-roadwise"
  : isEldNN
  ? "app-eld99"
  : isSt
  ? "app-eldSt"
  : isTe
  ? "app-eldte"
  : isEt
  ? "app-eldet"
  ? isSaferEld
  : "app-safereld"
  : "";
export const HTML_HEAD = isSmartelds
  ? htmlHeadSe
  : isUnity
  ? htmlHeadUnity
  : isEldBooks
  ? htmlHeadEb
  : isBluehorse
  ? htmlHeadBh
  : isVulcansols
  ? htmlHeadVs
  : isRadical
  ? htmlHeadRe
  : isApex
  ? htmlHeadAu
  : isRoadwise
  ? htmlHeadRw
  : isEldNN
  ? htmlHeadNN
  : isSt
  ? htmlHeadSt
  : isTe
  ? htmlHeadTe
  : isEt
  ? htmlHeadEt
  : isSaferEld
  ? htmlHeadSa
  : htmlHeadDefault;

export const LOGO_URL = isSmartelds
  ? LOGO_SM
  : isUnity
  ? LOGO_UNITY
  : isEldBooks
  ? LOGO_EB
  : isBluehorse
  ? SM_LOGO_BH
  : isVulcansols
  ? LOGO_VS
  : isRadical
  ? LOGO_RE
  : isApex
  ? LOGO_AU
  : isRoadwise
  ? LOGO_RW
  : isEldNN
  ? LOGO_NN
  : isSt
  ? LOGO_ST
  : isTe
  ? LOGO_TE
  : isEt
  ? LOGO_ET
  : isSaferEld
  ? LOGO_SA
  : "";

export const LOGIN_ADS = isSmartelds
  ? true
  : isUnity
  ? false
  : isEldBooks
  ? false
  : isBluehorse
  ? false
  : isVulcansols
  ? false
  : isRadical
  ? false
  : isApex
  ? false
  : isRoadwise
  ? false
  : isEldNN
  ? false
  : isSt
  ? false
  : isTe
  ? false
  : isEt
  ? false
  : isSaferEld
  ? false
  : false;

export const ADMIN_CONFIG = isSmartelds
  ? smarteldsAdminConfig
  : isUnity
  ? unityAdminConfig
  : isEldBooks
  ? eldBooksAdminConfig
  : isBluehorse
  ? bluehorseAdminConfig
  : isVulcansols
  ? vulcansolsAdminConfig
  : isRadical
  ? radicalAdminConfig
  : isApex
  ? apexAdminConfig
  : isRoadwise
  ? roadwiseAdminConfig
  : isEldNN
  ? eldNNAdminConfig
  : isSt
  ? eld247AdminConfig
  : isTe
  ? teAdminConfig
  : isEt
  ? etAdminConfig
  : isSaferEld
  ? saAdminConfig
  : smarteldsAdminConfig;

export const NAV_CONFIG = isSmartelds
  ? smarteldsNavConfig
  : isUnity
  ? unityNavConfig
  : isEldBooks
  ? eldBooksNavConfig
  : isBluehorse
  ? bluehorseNavConfig
  : isVulcansols
  ? vulcansolsNavConfig
  : isRadical
  ? radicalNavConfig
  : isApex
  ? apexNavConfig
  : isRoadwise
  ? roadwiseNavConfig
  : isEldNN
  ? eldNNNavConfig
  : isSt
  ? eld247NavConfig
  : isTe
  ? teNavConfig
  : isEt
  ? etNavConfig
  : isSaferEld
  ? saNavConfig
  : smarteldsNavConfig;

export const LOGO_WIDTH = isUnity
  ? 150
  : isUnity
  ? 250
  : isEldBooks
  ? 150
  : isBluehorse
  ? 150
  : isVulcansols
  ? 150
  : isRadical
  ? 100
  : isApex
  ? 100
  : isRoadwise
  ? 100
  : isEldNN
  ? 100
  : isSt
  ? 175
  : isTe
  ? 225
  : isEt
  ? 225
  : isSaferEld
  ? 225
  : 150;

export const RESELLER_PREFIX = isUnity
  ? "ME"
  : isEldBooks
  ? "EB"
  : isBluehorse
  ? "BH"
  : isVulcansols
  ? "VS"
  : isRadical
  ? "RE"
  : isApex
  ? "AU"
  : isSt
  ? "TS"
  : isEldNN
  ? "NN"
  : isTe
  ? "TE"
  : isEt
  ? "ET"
  : isSaferEld
  ? "SA"
  : "SE";
